import { APP_NAME } from "@calcom/lib/constants";
import { publicRuntimeValue } from "@calcom/lib/publicRuntimeConfig";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const customLogo = src === "/api/logo" ? publicRuntimeValue("NEXT_PUBLIC_BRAND_LOGO_LIGHT") : undefined;
  const customIcon = src === "/api/logo" ? publicRuntimeValue("NEXT_PUBLIC_BRAND_ICON") : undefined;
  const lightLogo = icon ? customIcon : customLogo;
  const darkLogo = icon ? customIcon : publicRuntimeValue("NEXT_PUBLIC_BRAND_LOGO_DARK") || customLogo;
  const wordmarkSize = small ? "h-4 w-auto" : "h-5 w-auto";
  const size = icon ? "mx-auto w-9" : wordmarkSize;

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {lightLogo ? (
          <>
            <img className={classNames(size, "dark:hidden")} alt={APP_NAME} src={lightLogo} />
            <img className={classNames(size, "hidden dark:block")} alt={APP_NAME} src={darkLogo} />
          </>
        ) : (
          <img
            className={classNames(size, "dark:invert")}
            alt={APP_NAME}
            title={APP_NAME}
            src={icon ? `${src}?type=icon` : src}
          />
        )}
      </strong>
    </h3>
  );
}
